<template>
    <div class="slides__slide specs grid-container">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell medium-20 large-12">

                <transition name="popup">
                    <div class="popup" v-if="visible">
                        <div v-on:click="visible = false" class="popup__bg"></div>
                        <div class="popup__content">
                            <div class="popup__image-bg">
                                <button v-on:click="visible = false" title="Close (Esc)" class="popup__close icon-close"/>
                                <img :src="slidedata.figureLarge" />
                            </div>
                        </div>
                    </div>
                </transition>

                <div class="text-content">
                    <h1>{{ slidedata.title }}</h1>
                    <p v-html="slidedata.text" />
                </div>

                <div class="specs-overview">
                    <h2>{{ slidedata.productName }}</h2>
                    <h3>{{ slidedata.configurationNumber }} {{ slidedata.productId }}</h3>

                    <div v-for="(productInfo, index) in slidedata.productInfos" :key="index">
                        <div v-if="index === 0">
                            <div class="grid-x grid-padding-x">
                                <div class="cell small-24 medium-7" v-if="slidedata.figure">
                                    <div v-on:click="visible = true" class="specs-overview__img">
                                        <figure>
                                            <img :src="slidedata.figure" :alt="slidedata.productName">
                                        </figure>
                                    </div>
                                </div>
                                <div class="cell small-24 medium-17">
                                    <table class="specs-table">
                                        <tr v-for="(spec, indexSecond) in productInfo.specs" :key="indexSecond">
                                            <td>{{ spec.key }}</td>
                                            <td>{{ spec.value }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="grid-x grid-padding-x">
                                <div class="cell">
                                    <h3 v-if="productInfo.title">{{ productInfo.title }}</h3>

                                    <table class="specs-table">
                                        <tr v-for="(spec, indexSecond) in productInfo.specs" :key="indexSecond">
                                            <td>{{ spec.key }}</td>
                                            <td>{{ spec.value }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button class="btn" @click.prevent="nextStep()">{{ slidedata.button }}<i class="icon-arrow-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            model: {
                type: 'form',
            },
        };
    },
    props: {
        slidedata: {
            default() {
                return {};
            },
            type: Object,
        },
        datamodel: {
            default() {
                return {};
            },
            type: Object,
        },
    },
    methods: {
        available(available) {
            if (!available) {
                return window.translations.notAvailable;
            }

            return '';
        },
        nextStep() {
            this.$emit('nextStep', this.model, true);
        },
    },
};
</script>
